import {
  ILogger,
  ISessionManager,
  WsError,
  WsErrorCodes,
  WsErrorTypes,
  IRegion,
  ICobranding,
} from '@amzn/work-spaces-web-client-core-lib';

export class Customization {
  private readonly cobranding: ICobranding;
  private readonly sessionManager: ISessionManager;
  private readonly logger: ILogger;

  constructor(
    cobranding: ICobranding,
    sessionManager: ISessionManager,
    logger: ILogger
  ) {
    this.cobranding = cobranding;
    this.sessionManager = sessionManager;
    this.logger = logger;
  }

  async fetchBrandingAssets(organizationName: string) {
    this.validate();
    const region = this.sessionManager.get('region') as IRegion;
    this.logger.info(
      `Retrieving branding assets for ${organizationName} in region:${region.endpoint}`
    );
    return await this.cobranding.fetchCobrandingAssets(
      region,
      organizationName
    );
  }

  // At this point we must have valid regCode
  private validate() {
    if (!this.sessionManager.get('region')) {
      this.logger.fatal('Missing region for registration');
      throw new WsError(
        WsErrorTypes.ERROR_TYPE_REGISTRATION,
        WsErrorCodes.ERROR_INVALID_REG_CODE
      );
    }
  }
}
